import { getRegisteredGlobal } from "@trumpf/ux.utils";
import { getIconSetRegistry, IconSetResolver, NAMESPACE, parseIconFromName } from "./iconset-registry";

declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        trumpf: any;
    }
}

describe("IconSetRegistry", () => {
    beforeEach(() => {
        delete window.trumpf;
    });

    it("getIconSetRegistry() returns the globally registered IconSetRegistry instance", () => {
        const registry = getIconSetRegistry();
        expect(getIconSetRegistry()).toBe(registry);
        expect(getRegisteredGlobal(NAMESPACE)).toBe(registry);
    });

    it('registers the default "uic" icon set by default', () => {
        const registry = getIconSetRegistry();
        expect(registry.getSet("uic")).toBeDefined();
        expect(
            registry.resolveIconSrc({
                iconSet: "uic",
                iconName: "user"
            })
        ).toEqual("/icons/icons.svg#user");
    });

    it("adds and removes custom icon sets correctly", () => {
        const registry = getIconSetRegistry();

        // add set
        const resolver: IconSetResolver = jest.fn((name: string) => {
            return `/assets/custom-icons.svg#${name}`;
        });
        registry.addSet("test", resolver);
        expect(registry.getSet("test")).toEqual({
            name: "test",
            resolver,
            mutator: undefined
        });
        expect(
            registry.resolveIconSrc({
                iconSet: "test",
                iconName: "logo"
            })
        ).toEqual("/assets/custom-icons.svg#logo");

        // remove set
        registry.removeSet("test");
        expect(registry.getSet("test")).toBeUndefined();
        expect(
            registry.resolveIconSrc({
                iconSet: "test",
                iconName: "logo"
            })
        ).toEqual("#logo");
    });

    it("parseIconFromName returns the correct icon link", () => {
        expect(parseIconFromName("user")).toEqual({
            iconName: "user",
            iconSet: "default"
        });
        expect(parseIconFromName("uic:user")).toEqual({
            iconName: "user",
            iconSet: "uic"
        });
    });
});
